<a [attr.href]="config()?.href || '#'" [attr.title]="config()?.title" [attr.aria-label]="ariaLabel() || null" (click)="onClicked($event)">
  <ng-content />
</a>
